// CSS gradient stops for each colormap (index matches shader ApplyColormap dispatcher)
// Direction is always left=0.0 (low) → right=1.0 (high).
// Use getColormapGradient(index, reversed) to get a distance-safe gradient.

const GRADIENT_STOPS = [
  // 0: Turbo
  '#30123b, #4145ab, #2a9df4, #26c7c9, #3ddc84, #a8eb12, #f9c74f, #f9844a, #f94144',
  // 1: Viridis
  '#440154, #3b528b, #21918c, #5ec962, #fde725',
  // 2: Magma
  '#000004, #3b0f70, #8c2981, #de4968, #fe9f6d, #fcfdbf',
  // 3: Inferno
  '#000004, #420a68, #932667, #dd513a, #fca50a, #fcffa4',
  // 4: Cividis (8 LUT stops)
  '#00204d, #102f67, #26407d, #43548c, #6c6b8f, #968485, #c1a071, #fef97a',
  // 5: CET-L1 (perceptually uniform greyscale)
  '#000000, #ffffff',
];

/**
 * Returns a CSS linear-gradient string for a given colormap index.
 * @param {number} index - Colormap index (0–5)
 * @param {boolean} reversed - If true, reverses the gradient direction (used for distance mode)
 */
export const getColormapGradient = (index, reversed = false) => {
  const stops = GRADIENT_STOPS[index] ?? GRADIENT_STOPS[0];
  const dir = reversed ? 'to left' : 'to right';
  return `linear-gradient(${dir}, ${stops})`;
};
